import React, { useState } from "react";
import AuthLayout from "../components/authLayout";
import { Form } from "antd";
import { useNavigate } from "react-router-dom";
import "./style.scss";
import SuccessModal from "components/Account/components/successModal/index ";
import BrandLogo from "assets/images/svg/click-for-marry02.svg";
import Password from "components/BaseWidgets/form/password";
import Input from "components/BaseWidgets/form/input";
import Button from "components/BaseWidgets/button";

function ResetPassword() {
  const [password, setPassword] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const onFinish = (values) => {
    setOpenModal(true);
  };

  const handleCancel = () => {
    setOpenModal(false);
  };

  return (
    <>
      <AuthLayout childrenClass="custom-auth-layout">
        <div className="login-otp-wrapper">
          <div className="brand-logo">
            <img className="logo" src={BrandLogo} alt="Logo" />
          </div>
          <Button isBack onClick={() => navigate(-1)}></Button>
          <div className="page-heading">
            <h2 className="title font-title-xl mb-2">Reset password</h2>
            <p className="subtitle font-body-xs">
              Set a new password that’s different from the previous password.
            </p>
          </div>

          <div className="auth-form-container">
            <Form
              form={form}
              className="login-form"
              onFinish={onFinish}
              layout="vertical"
            >
              <Form.Item
                name="password"
                className="custom-error"
                rules={[
                  { required: true, message: "Please enter your password!" },
                  {
                    min: 6,
                    message: "Password must be at least 6 characters long!",
                  },
                ]}
              >
                <Password
                  id="password"
                  labelClass={`label`}
                  label="Password"
                  className="mt-2"
                  placeholder=""
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Item>

              <Form.Item
                name="confirmPassword"
                dependencies={["password"]}
                className="custom-error"
                rules={[
                  { required: true, message: "Please confirm your password!" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Passwords do not match!"),
                      );
                    },
                  }),
                ]}
              >
                <Password
                  id="confirm-password"
                  labelClass={`label`}
                  label="Confirm Password"
                  className="mt-6"
                  placeholder=""
                />
              </Form.Item>

              <Button
                htmlType="submit"
                onClick={() => {
                  form.validateFields().catch((err) => {

                  });
                }}
                className={"mt-8 mb-6"}
                wFull
              >
                Submit
              </Button>
            </Form>
          </div>
        </div>
      </AuthLayout>
      <SuccessModal
        title="Password changed!"
        description="  Your password has been changed successfully. Use your new password to
          log in."
        onOk={() => {
          navigate("/login");
          handleCancel();
        }}
        open={openModal}
        onCancel={handleCancel}
      />
    </>
  );
}

export default ResetPassword;
